<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style>
#app {
	font-family: "Inconsolata", Courier, monospace;
}
</style>



// WEBPACK FOOTER //
// src/App.vue